export default __webpack_public_path__ + "static/media/fad-thunderbolt.dbe22b73.svg";